import { TestTube } from '@phosphor-icons/react';

import { cn } from '@/lib/utils';
import { useInvoiceFlow } from '../hooks/useInvoiceFlow';

/**
 * Prueba o real, junto al asistente en las dos barras. Solo con la bandera del
 * «Modo testing»; sin ella no se pinta y todo sale real.
 *
 * Encendido es prueba, como el switch del flujo legacy. Apagado se pinta en
 * ámbar para que timbrar de verdad nunca pase desapercibido.
 */
export const EmissionModeToggle = () => {
  const { canChooseEmissionMode, isTestEmission, setTestEmission } = useInvoiceFlow();
  if (!canChooseEmissionMode) return null;

  return (
    <button
      type='button'
      role='switch'
      aria-checked={isTestEmission}
      aria-label='Factura de prueba'
      title={
        isTestEmission
          ? 'Factura de prueba: no vale ante el SAT'
          : 'Timbrado real: la factura vale ante el SAT'
      }
      onClick={() => setTestEmission(!isTestEmission)}
      className={cn(
        'flex min-h-9 flex-none items-center gap-1.5 rounded-full border px-2 text-[13px] font-medium transition-colors duration-150 active:scale-[0.96] sm:px-3',
        isTestEmission
          ? 'border-h-neutral-90 text-h-text-heading bg-white'
          : 'border-h-warning-50 bg-h-warning-95 text-h-warning-30',
      )}>
      <TestTube size={16} weight={isTestEmission ? 'regular' : 'fill'} />
      <span className='hidden sm:inline'>{isTestEmission ? 'Prueba' : 'Real'}</span>
      <span
        aria-hidden
        className={cn(
          'relative h-4 w-7 flex-none rounded-full transition-colors duration-150',
          isTestEmission ? 'bg-h-primary-50' : 'bg-h-warning-50',
        )}>
        <span
          className={cn(
            'absolute top-0.5 size-3 rounded-full bg-white shadow-sm transition-all duration-150',
            isTestEmission ? 'left-[14px]' : 'left-0.5',
          )}
        />
      </span>
    </button>
  );
};
